import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/alarm.svg';

export const IconAlarm = createIconComponent(Icon);
